var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.782 16.107 13.79 6.103c-.737-1.475-2.843-1.475-3.58 0L5.219 16.107A2 2 0 0 0 7.008 19h9.985a2 2 0 0 0 1.79-2.893M15.58 5.21c-1.473-2.951-5.685-2.951-7.158 0L3.428 15.213C2.101 17.874 4.035 21 7.008 21h9.985c2.972 0 4.906-3.127 3.579-5.786z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 8a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-1 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
  })));
};
export default SvgAlert;